export const realtorInviteButtonStyles = { mt: 1 };

export const configSelectStyles = { mb: 1, maxWidth: 260 };
